// store/index.js

import { createStore } from 'vuex';
import wishList from '@/modules/wishList';
import layerPopup from '@/modules/layerPopup';

const store = createStore({
  modules:{
    wishList,     //위시리스트 
    layerPopup,   //레이어팝업
  }
})

export default store;

// export default createStore({
//   state: {
//     /*
//     // 상태(state) 정의
//     1.state는 쉽게 말하면 프로젝트에서 공통으로 사용할 변수를 정의한다.
//     2.프로젝트 내의 모든 곳에서 참조 및 사용이 가능하다.
//     3.state를 통해 각 컴포넌트에서 동일한 값 사용 가능하다.
//     4.state는 mutations를 통해서만 변경이 가능하다.
//     */
//   },
//   mutations: {
//     /*
//     // 뮤테이션(mutations) 정의
//     1.Mutations의 주요 목적은 state를 변경시키는 것이다.
//     2.비동기 처리가 아닌 동기 처리를 한다. 위의 함수가 실행되고 종료된 후 그 다음 아래의 함수가 실행된다.
//     3.commit('함수명', '전달인자')으로 실행 시킨다.
//     4.mutations 내에 함수 형태로 작성한다.
//     */
//   },
//   actions: {
//     /*
//     // 액션(actions) 정의
//     1.Actions의 주요 목적은 mutations를 실행시키는 것 이다.
//     2.동기 처리가 아닌 비동기 처리를 한다. 순서에 상관없이 먼저 종료된 함수의 피드백을 받아 후속 처리 하게 된다.
//     3.dispatch('함수명','전달인자')로 실행시킬 수 있다.
//      => ex) dispatch('함수명', '전달인자', {root:true})
//     4.actions 내에 함수 형태로 작성한다.
//     5.비동기 처리이기 때문에 콜백 함수로 주로 작성한다.
//     */
//   },
//   getters: {
//     /*
//     // 게터(getters) 정의
//     1.각 components의 계산된 속성의 공통 사용 정의
//     2.여러 components에서 동일한 computed가 사용 될 경우 Getters에 정의하여 공통으로 쉽게 사용할 수 있다.
//     3.하위 모듈의 getters를 불러오기 위해서는,
//      => this.$store.getters["경로명/함수명"];을 사용해야 한다.
//     */
//   }
// })